export default {"src":"/_next/static/media/auctionsIcon.0e068101.svg","height":24,"width":24};